<script>
export const pageName = 'account-preferences';
export const pageRoute = '/account/preferences';
export const title = 'Preferences'
export const requireEmailVerified = false;

import { navigate } from '@trullock/page-manager';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { showToast } from '../../js/utils/toast.js';
import { commands } from '../../js/lib/functions.js'
import { getAllClubViews, listenToCurrentUserView } from '../../js/readModel.js';

export default {
	data() {
		return {
			currentUser: null,
			clubs: [],
			ready: false,
			isDirty: false
		 }
	},
	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async boot(opts) {
			// no need to subscribe, this wont change with any regularity
			this.clubs = (await getAllClubViews()).map(c => ({
				id: c.id,
				name: c.name,
				subscribed: true,
				ukraAffiliated: c.ukraAffiliated
			}));

			this.clubs.sort((a, b) => a.name.localeCompare(b.name))

			await listenToCurrentUserView(user => this.currentUser = user);
		},
		show()
		{
			commands.warmUp();
			
			// We want to be subscribed to all (new) clubs by default
			// reset
			this.clubs.forEach(c => c.subscribed = c.ukraAffiliated);
			// set
			this.currentUser.clubUnsubscriptions.forEach(clubId => {
				let club = this.clubs.find(c => c.id == clubId);
				club && (club.subscribed = false);
			})

			this.isDirty = false
		},
		changed() {
			this.isDirty = true;
		},
		async submit() {
			showLoading();

			let result = await commands.users.account.setClubUnsubscriptions({
				clubIds: this.clubs.filter(c => !c.subscribed).map(c => c.id)
			})

			hideLoading();

			this.isDirty = false;

			navigate('/');

			showToast({
				message: 'Preferences updated',
				style: 'bg-success'
			})
		}
	}
}

</script>
<template>
<div class="container">
	<div class="row justify-content-center">
		<div class="col-12 col-md-6 my-5">
			<h1 class="display-4 text-center mb-3">Preferences</h1>
			<p class="text-muted text-center mb-5">Set things up how you like.</p>
			<form @submit.prevent="submit" @change="changed">
				<fieldset class="mb-4">
					<h3>Club notifications</h3>
					<p>Select the clubs from which you would like to receive event notifications and other relevant communication.</p>
					<div v-for="club in clubs" class="form-group mb-4">
						<div class="custom-control custom-switch">
							<input type="checkbox" class="custom-control-input" v-model="club.subscribed" :disabled="!club.ukraAffiliated">
							<label class="custom-control-label d-block">{{ club.name }}</label>
						</div>
						<p v-if="!club.ukraAffiliated" class="small text-muted mt-2">This club is not UKRA Affiliated.</p>
					</div>
				</fieldset>
				<button type="submit" class="btn btn-lg btn-block btn-primary mb-3">Update preferences <span class="fe fe-check-circle"></span></button>
			</form>
		</div>
	</div>
</div>
</template>